import React from "react";
import { Button } from "./button";
import { ThumbsUp, MessageCircle } from "lucide-react";
import ShareComponent from "./ShareComponent";

const ArticleActions = () => {
  return (
    <>
        <div className="flex items-center gap-6">
          <Button variant="ghost" size="sm">
            <ThumbsUp className="w-4 h-4 mr-1" />
            {Math.floor(Math.random() * 50) + 10}
          </Button>
          <Button variant="ghost" size="sm">
            <MessageCircle className="w-4 h-4 mr-1" />
            {Math.floor(Math.random() * 20) + 5}
          </Button>
        </div>
    </>
  );
};

export default ArticleActions;
